export default class InvalidError extends Error {
  constructor(message, errors) {
    super(message)
    this.name = 'InvalidError'
    this.errors = errors
  }
}
